import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=e5f1007c&scoped=true"
import script from "./footer.js?vue&type=script&lang=js&external"
export * from "./footer.js?vue&type=script&lang=js&external"
import style0 from "./footer.scss?vue&type=style&index=0&id=e5f1007c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f1007c",
  null
  
)

export default component.exports